import {
  HEX_292D38,
  HEX_3E4B68,
  HEX_477FBA,
  HEX_646A7E,
  HEX_ADB5C7,
  HEX_B8C7D5,
} from '@tanium/colors';
import { defineColor } from '@tanium/react-theme-definition';

export const ParentPageText = defineColor([HEX_3E4B68, HEX_B8C7D5]);
export const ParentPageTextHover = defineColor([HEX_292D38, HEX_B8C7D5]);
export const CurrentPageText = defineColor([HEX_646A7E, HEX_B8C7D5]);
export const CaretFill = defineColor([HEX_ADB5C7, HEX_477FBA]);
